import { TriangleAlert } from 'lucide-react'
import { INSTALLER_FILE_NAME, WINDOWS_STRINGS, type WindowsLang } from './windows-strings'

export function BrowserWarningMock({ lang }: { lang: WindowsLang }) {
  const s = WINDOWS_STRINGS[lang]

  return (
    <div aria-hidden="true" className="select-none rounded-lg border border-black/10 bg-white p-3 font-sans text-[#1f1f1f] shadow-lg">
      <div className="flex items-start gap-2">
        <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
        <div className="min-w-0">
          <p className="truncate text-[12px] font-medium">{INSTALLER_FILE_NAME}</p>
          <p className="text-[11px] text-black/60">{s.brWarning}</p>
        </div>
      </div>
      <div className="mt-3 flex justify-end gap-2 text-[11px] font-medium">
        <span className="rounded-full px-3 py-1 text-[#0b57d0]">{s.brDelete}</span>
        <span className="rounded-full px-3 py-1 text-[#0b57d0] ring-2 ring-amber-400">{s.brKeep}</span>
      </div>
    </div>
  )
}
